import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { user_values } from "../../../../../public/assets";
import { user_values1 } from "../../../../../public/assets";
import { selectLocale } from "../../../../locales/localeSlice";
import {
  DesignContainer,
  DesignContainer1,
  SubtitleText,
  TitleText,
  TitleText1,
  TitleText2,
  User,
  ValuesContainer1,
} from "../ValueElements.styles";

const Design = () => {
  const { t } = useTranslation();
  const currentLocale = useSelector(selectLocale);
  return (
    <DesignContainer>
      <User src="/assets/svg/Round_user.png" />
      <TitleText>
        {t("EthicsValue.cardTwo.title", {
          lng: currentLocale,
        })}
      </TitleText>
      <SubtitleText>
        {t("EthicsValue.cardTwo.content", {
          lng: currentLocale,
        })}
      </SubtitleText>
    </DesignContainer>
  );
};

export default Design;

/***************************************************************************************/

export const RealNotifications = () => {
  const { t } = useTranslation();
  const currentLocale = useSelector(selectLocale);
  return (
    <DesignContainer1>
      <User src="/assets/svg/Round_user1.png" />
      <TitleText>
        {t("SecurityPage.cardTwo.title", {
          lng: currentLocale,
        })}
      </TitleText>
      <SubtitleText>
        {t("SecurityPage.cardTwo.content", {
          lng: currentLocale,
        })}
      </SubtitleText>
    </DesignContainer1>
  );
};

/*********************************************************************************************** */

export const SecureTransactions = () => {
  const { t } = useTranslation();
  const currentLocale = useSelector(selectLocale);
  return (
    <ValuesContainer1>
      <User src="/assets/svg/Round_user1.png" />
      <TitleText2>
        {t("SecurityPage.cardFive.title", {
          lng: currentLocale,
        })}
      </TitleText2>
      <SubtitleText>
        {t("SecurityPage.cardFive.content", {
          lng: currentLocale,
        })}
      </SubtitleText>
    </ValuesContainer1>
  );
};
